<template>
    <div
        class="uk-height-1-1 uk-width-1-1 uk-background-primary uk-border-rounded uk-box-shadow-small uk-padding-small graph-container"
    >
        <!-- <graph-submenu :position="graphPosition" /> -->
        <div class="graph-buttons uk-width-1-1">
            <graph-help :graph-id="id" />
        </div>
        <div class="uk-position-medium uk-position-top-left">
            <span class="uk-text-large uk-text-lead uk-text-bolder">{{ getAggregatedValue }}</span>
            <span
                v-if="difference !== 0"
                class="uk-text-small-number margin-left-small"
                :class="{ 'uk-text-danger': difference < 0, 'uk-text-success': difference > 0 }"
            >
                <i :class="{ 'rotate-135': difference < 0, 'rotate-45': difference > 0 }">
                    <img
                        v-if="difference !== 0"
                        :src="require('@/assets/images/icons/icon-arrow-up.svg')"
                        class="tragnsition-transform"
                        :class="{
                            'rotate-90': difference < 0,
                            'uk-fill-danger': difference < 0,
                        }"
                        uk-svg
                    />
                </i>
                {{ differenceLocal }}%
            </span>
            <span v-else>
                <span class="uk-text-warning margin-left-small"> {{ differenceLocal }}% </span> </span
            ><br />
            <span class="uk-text-meta">{{ title }}</span>
            <small class="uk-text-meta"> {{ infoText }}</small>
        </div>

        <line-part :chart-data="getChartData" />

        <slot />

        <graph-modal :graph-id="id" :title="title" :description="description" />
    </div>
</template>

<script lang="js">
import Vue from "vue";
import LinePart from "./graphParts/LinePart.vue";
import GraphsMixin from "@/mixins/graphs-mixin";
import GraphHelp from "./graphParts/GraphHelp.vue";
import GraphModal from "./graphParts/GraphModal.vue";

export default GraphsMixin.extend({
    name: "LineGraph",
    components: { LinePart, GraphHelp, GraphModal },
    mixins: [GraphsMixin],
});
</script>
